 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTMLCOVER from '@/components/html/cover'
 import HTMLLOVE_1 from '@/components/html/love_1'
 import HTML9780230339934_01_PREXIV from '@/components/html/9780230339934_01_Prexiv'
 import HTMLNOTICE from '@/components/html/notice'
 import HTMLDED from '@/components/html/ded'
 import HTML9780230339934_02_INT from '@/components/html/9780230339934_02_int'
 import HTML9780230339934_03_CH01 from '@/components/html/9780230339934_03_ch01'
 import HTML9780230339934_04_CH02 from '@/components/html/9780230339934_04_ch02'
 import HTML9780230339934_05_CH03 from '@/components/html/9780230339934_05_ch03'
 import HTML9780230339934_06_CH04 from '@/components/html/9780230339934_06_ch04'
 import HTML9780230339934_07_CH05 from '@/components/html/9780230339934_07_ch05'
 import HTML9780230339934_08_CH06 from '@/components/html/9780230339934_08_ch06'
 import HTML9780230339934_09_CH07 from '@/components/html/9780230339934_09_ch07'
 import HTML9780230339934_10_CH08 from '@/components/html/9780230339934_10_ch08'
 import HTML9780230339934_11_CH09 from '@/components/html/9780230339934_11_ch09'
 import HTML9780230339934_12_CH10 from '@/components/html/9780230339934_12_ch10'
 import HTMLLOVE_2 from '@/components/html/love_2'
 import HTML9780230339934_13_ACK from '@/components/html/9780230339934_13_ack'
 import HTML9780230339934_14_NOT from '@/components/html/9780230339934_14_not'
 import HTML9780230339934_15_IND from '@/components/html/9780230339934_15_ind'
 import HTML9780230339934_01_PREXIV1 from '@/components/html/9780230339934_01_Prexiv1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/cover",
 			"name" : "html/cover",
 			"component" : HTMLCOVER
 		},
 		{
 			"path" : "/html/love_1",
 			"name" : "html/love_1",
 			"component" : HTMLLOVE_1
 		},
 		{
 			"path" : "/html/9780230339934_01_Prexiv",
 			"name" : "html/9780230339934_01_Prexiv",
 			"component" : HTML9780230339934_01_PREXIV
 		},
 		{
 			"path" : "/html/notice",
 			"name" : "html/notice",
 			"component" : HTMLNOTICE
 		},
 		{
 			"path" : "/html/ded",
 			"name" : "html/ded",
 			"component" : HTMLDED
 		},
 		{
 			"path" : "/html/9780230339934_02_int",
 			"name" : "html/9780230339934_02_int",
 			"component" : HTML9780230339934_02_INT
 		},
 		{
 			"path" : "/html/9780230339934_03_ch01",
 			"name" : "html/9780230339934_03_ch01",
 			"component" : HTML9780230339934_03_CH01
 		},
 		{
 			"path" : "/html/9780230339934_04_ch02",
 			"name" : "html/9780230339934_04_ch02",
 			"component" : HTML9780230339934_04_CH02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js